import Onlinelekce from './Onlinelekce'

export default Onlinelekce
